// extracted by mini-css-extract-plugin
export default {"container":"_2QH9","nomargin":"V3Gp","selectAll":"zJZd"};